var map = {
	"./arrow-right.svg": "ea8f",
	"./contents.svg": "6598",
	"./directory.svg": "fe85",
	"./exam.svg": "047d",
	"./export.svg": "5292",
	"./fold_1.svg": "d37b",
	"./fold_2.svg": "2639",
	"./fullscreen-expand-round.svg": "fab2",
	"./fullscreen-shrink-round.svg": "ee31",
	"./language.svg": "ce92",
	"./one.svg": "3e58",
	"./professional-life.svg": "e706",
	"./research-skills.svg": "3bbf",
	"./skip.svg": "76c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95ff";